import CONFIG from "../config"

const networks = {
    '0x1': 'Ethereum Mainnet',
    '0x3': 'Ropsten {0}',
    '0x4': 'Rinkeby {0}',
    '0x5': 'Goerli {0}',
    '0x42': 'Kovan {0}'
}

export const COMMON = {
    appName: 'Chain of Events',
    networks,
    en: {
        about: 'About',
        account: 'Address',
        addNode: 'Add a Node',
        addConnection: 'Connect',
        add: 'Add',
        amount: 'Amount',
        boardName: 'Board Name',
        cancel: 'Cancel',
        close: 'Close',
        collection: 'My Collection',
        connections: 'Connections',
        connectToMetaMask: 'Connect to MetaMask',
        delete: 'Delete',
        disconnect: 'Disconnect',
        etherscan: 'Etherscan',
        evidence: 'Evidence',
        event: 'Event',
        eventData: {
            date: 'Date'
        },
        fileCorrupt: 'The board you attempted to open is malformatted. Unable to load.',
        goerliOnly: "Don't use anything but Goerli Test Network for testing!!",
        implicatedParty: 'Implicated Party',
        install: 'Install MetaMask',
        makeOffer: 'Make an Offer',
        marketplace: 'Marketplace',
        metamask: 'MetaMask',
        mintToBlockchain: 'Mint NFT',
        nodeType: 'Node Type',
        notConnectedTitle: "Your Wallet is Locked",
        get notConnectedBody(){
            return `Please unlock your wallet to view your ${ COMMON.appName } NFTs.`;
        },
        people: 'People',
        person: 'Person',
        place: 'Place',
        offers: 'My Offers',
        organization: 'Organization',
        organizationData: {
            headquarters: 'Headquarters Address',
            industry: 'Industry'
        },
        personData: {
            bornOn: 'Born on',
            diedOn: 'Died on',
            ethnicity: 'Ethnicity',
            gender: 'Gender',
            height: 'Height',
            nationality: 'Nationality',
            politicalAffiliation: 'Political Affiliation',
            weight: 'Weight'
        },
        placeData: {
            address: 'Address',
            coordinates: 'Global Coordinates'
        },
        shared: {
            description: 'Brief Description',
            image: 'Photograph'
        },
        tokenHistory: 'Token History',
        transferBoard: 'Transfer Ownership',
        walkthrough: 'Help',
        wrongNetwork: `You must be on ${ networks[ CONFIG.network ] } to continue.`,
    }
}